// This file is auto-generated. Do not modify the content!
// To generate the content, run the command: npm run generate-icon
import React from "react";
import { Accessories } from "./Accessories";
import { AdoptionTracking } from "./AdoptionTracking";
import { ArrowLeft } from "./ArrowLeft";
import { ArrowRight } from "./ArrowRight";
import { Bell } from "./Bell";
import { Calendar } from "./Calendar";
import { Camera } from "./Camera";
import { Cat } from "./Cat";
import { Checked } from "./Checked";
import { Clock } from "./Clock";
import { Close } from "./Close";
import { Dog } from "./Dog";
import { Edit } from "./Edit";
import { Filter } from "./Filter";
import { Fleaing } from "./Fleaing";
import { FoodPlan } from "./FoodPlan";
import { Heart } from "./Heart";
import { IncompletePets } from "./IncompletePets";
import { Location } from "./Location";
import { MedicalPlan } from "./MedicalPlan";
import { Message } from "./Message";
import { OngoingApplications } from "./OngoingApplications";
import { PetDoB } from "./PetDoB";
import { PetGender } from "./PetGender";
import { PetType } from "./PetType";
import { Photo } from "./Photo";
import { Plus } from "./Plus";
import { Search } from "./Search";
import { Send } from "./Send";
import { Settings } from "./Settings";
import { SingleGender } from "./SingleGender";
import { Spaying } from "./Spaying";
import { SuccessfulAdoptions } from "./SuccessfulAdoptions";
import { Swap } from "./Swap";
import { Vaccine } from "./Vaccine";
import { Wallet } from "./Wallet";
import { Weight } from "./Weight";
import { Work } from "./Work";
import { Worming } from "./Worming";

function Icon() {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}

Icon.Accessories = Accessories;
Icon.AdoptionTracking = AdoptionTracking;
Icon.ArrowLeft = ArrowLeft;
Icon.ArrowRight = ArrowRight;
Icon.Bell = Bell;
Icon.Calendar = Calendar;
Icon.Camera = Camera;
Icon.Cat = Cat;
Icon.Checked = Checked;
Icon.Clock = Clock;
Icon.Close = Close;
Icon.Dog = Dog;
Icon.Edit = Edit;
Icon.Filter = Filter;
Icon.Fleaing = Fleaing;
Icon.FoodPlan = FoodPlan;
Icon.Heart = Heart;
Icon.IncompletePets = IncompletePets;
Icon.Location = Location;
Icon.MedicalPlan = MedicalPlan;
Icon.Message = Message;
Icon.OngoingApplications = OngoingApplications;
Icon.PetDoB = PetDoB;
Icon.PetGender = PetGender;
Icon.PetType = PetType;
Icon.Photo = Photo;
Icon.Plus = Plus;
Icon.Search = Search;
Icon.Send = Send;
Icon.Settings = Settings;
Icon.SingleGender = SingleGender;
Icon.Spaying = Spaying;
Icon.SuccessfulAdoptions = SuccessfulAdoptions;
Icon.Swap = Swap;
Icon.Vaccine = Vaccine;
Icon.Wallet = Wallet;
Icon.Weight = Weight;
Icon.Work = Work;
Icon.Worming = Worming;
export { Icon };
//# sourceMappingURL=index.js.map